import { getLogger } from '@arcivr/sp-ui-lib'

export default getLogger('stream-tools-ui')
